import React from 'react'
import PropTypes from 'prop-types'

import CopyTextOnClick from '../../../Shared/CopyTextOnClick'

function RulesPageEmbedBadges({ badges, competitionTitle }) {
  return (
    <div className="row embed-badges">
      {badges.map((badge, index) => {
        return (
          <div className="col-12 col-md-6 badge-container" key={badge.link}>
            <a href="https://www.cgtrader.com" target="_blank" className="u-text-center">
              <img
                className="badge-img"
                src={require(`images/competitions/digital_art/${badge.title}.png`)}
                alt={`CGTrader ${competitionTitle}`}
              />
            </a>
            <CopyTextOnClick text={badge.code} id={`badge-code-${index}`}>
              <div className="code-area">
                <code>{badge.code}</code>
              </div>
            </CopyTextOnClick>
          </div>
        )
      })}
    </div>
  )
}

RulesPageEmbedBadges.propTypes = {
  badges: PropTypes.array.isRequired,
  competitionTitle: PropTypes.string.isRequired,
}

export default RulesPageEmbedBadges
